<label>{{ props.label }}</label>
